;(function($, undefined){

    var rnn = window.rnn;
    var currentUser, enabled, models, useRGBA, useCookies;

    function show(model) { models[model] = true; }
    function hide(model) { models[model] = false; }

    function updateModels() {
        var allOverlayModels, modelsCookie;

        if (currentUser.allowed_models) {

            allOverlayModels = [];

            if (useCookies) {
                modelsCookie = Cookies.get("adminUIOverlaysModels");
                if (!modelsCookie) {
                    Cookies.set("adminUIOverlaysModels", ":", { path: "/" });
                }
            }

            $("*[data-overlay-marker]").each(function () {
                allOverlayModels.push($(this).data("overlay-marker").content_type);
            });

            _.uniq(allOverlayModels).fastEach(function (overlayModel) {
                overlayModel && currentUser.allowed_models.fastEach(function (allowedModel) {
                    if (overlayModel === allowedModel || overlayModel.indexOf(allowedModel + '_') === 0) {
                        if (typeof models[overlayModel] === "undefined") {
                            if (!!modelsCookie && modelsCookie.indexOf([":", overlayModel, ":"].join("")) > -1) {
                                show(overlayModel); // add and set to true
                            } else {
                                hide(overlayModel); // add and set to false
                            }
                        }
                        return true;
                    }
                });
            });
        }
    }

    function renderToggles() {
        var labelCSS, checkboxCSS, $overlayToggles;

        labelCSS = {
            "display":          "block",
            "margin-bottom":    "6px",
            "font-size":        "13px",
            "font-weight":      "normal",
            "line-height":      "1.2"
        };

        checkboxCSS = {
            "vertical-align":   "bottom",
            "display":          "inline",
            "margin":           "2px 10px 0 0"
        };

        $overlayToggles = $("#overlayToggles");
        if ($overlayToggles.length > 0) {
            $overlayToggles.hide().empty();
            _.keys(models).sort().fastEach(function (key) {

                function checked() {
                    if (models[key] === true) {
                        return "checked='checked' ";
                    } else {
                        return "";
                    }
                }

                $overlayToggles.append(
                    $(["<label>", key, "</label>"].join(""))
                    .css(labelCSS)
                    .prepend(
                        $(["<input type='checkbox' name='models' value='", key, "'", checked(models[key]), "/>"].join(""))
                        .css(checkboxCSS)
                    )
                );
            });
            $overlayToggles.find("input[type=checkbox]").bind("change", function () {
                var $checkbox, model, modelsCookie,
                    isChecked, modelsCookieNewValue, fn;

                $checkbox = $(this);
                model = $checkbox.val();
                isChecked = $checkbox.is(":checked");

                if (useCookies) {
                    modelsCookie = Cookies.get("adminUIOverlaysModels");
                    if (!!modelsCookie) {
                        if (modelsCookie.indexOf([":", model, ":"].join("")) < 0 && isChecked) {
                            modelsCookieNewValue = [modelsCookie, model, ":"].join("");
                        } else {
                            modelsCookieNewValue = modelsCookie.replace([model, ":"].join(""), "");
                        }
                        Cookies.set("adminUIOverlaysModels", modelsCookieNewValue, { path: "/" });
                    }
                }

                fn = isChecked ? show : hide;
                refresh(fn, model);
            });
            if ($overlayToggles.find("label").length === 0) {
                $overlayToggles.append($("<p>None</p>"));
            }
            $overlayToggles.show();
        }
    }

    function destroyOverlays() {
        $("*[data-overlay]").remove();
    }

    function renderOverlays() {
        var overlays, visibleSourceElementsByModel;

        overlays = [];
        destroyOverlays();

        if (enabled) {

            visibleSourceElementsByModel = {};
            $("*[data-overlay-marker]:visible").each(function () {
                var $this, model;

                $this = $(this);
                model = $this.data("overlay-marker").content_type;
                if (!visibleSourceElementsByModel[model]) {
                    visibleSourceElementsByModel[model] = [$this];
                } else {
                    visibleSourceElementsByModel[model].push($this);
                }
            });

            $.each(models, function (key, value) {
                var labelCSS, labelContentModelCSS;

                labelCSS = {
                    "display":          "block",
                    "font-size":        "12px",
                    "line-height":      "1.5",
                    "color":            "#FFF",
                    "padding":          "0 4px 2px",
                    "background-color": useRGBA ? "rgba(0, 0, 0, 0.7)" : "#000"
                };

                labelContentModelCSS = {
                    "font-weight":      "bold",
                    "float":            "right",
                    "margin-left":      "6px"
                };

                if (value === true && visibleSourceElementsByModel[key]) {
                    $.each(visibleSourceElementsByModel[key], function () {
                        var $instance, overlayData, offset, width, height,
                            zIndex, isFullyObscured, contentModel, contentLabel,
                            contentEditUrl, isSupplemental, $overlay, $label;

                        $instance       = $(this);
                        overlayData     = $instance.data("overlay-marker");
                        offset          = $instance.offset();
                        width           = $instance.outerWidth();
                        height          = $instance.outerHeight();
                        contentModel    = overlayData.content_type;
                        contentLabel    = overlayData.label;
                        contentEditUrl  = overlayData.edit_url;
                        isSupplemental  = overlayData.is_supplemental;
                        zIndex          = "2000";
                        isFullyObscured = false;

                        $instance.parents().each(function () {
                            var $parent, parentZindex,
                                parentPos, instancePos;

                            $parent         = $(this);
                            parentZindex    = $parent.css("z-index");

                            if (parentZindex !== "auto" && parentZindex > zIndex) {
                                zIndex = parentZindex;
                            }
                            if (!isFullyObscured && $parent.css("overflow") === "hidden") {
                                parentPos   = $parent.offset();
                                instancePos = $instance.offset();
                                if (
                                    instancePos.left + width <= parentPos.left ||
                                    instancePos.left >= parentPos.left + $parent.outerWidth() ||
                                    instancePos.top + height <= parentPos.top ||
                                    instancePos.top >= parentPos.top + $parent.outerHeight()
                                ) {
                                    isFullyObscured = true;
                                }
                            }
                        });

                        if (!isFullyObscured && $instance.css("opacity") === "1") {
                            $overlay = $(["<div data-overlay='", contentModel, "'></div>"].join(""))
                            .css({
                                "position":         "absolute",
                                "top":              offset.top,
                                "left":             offset.left,
                                "width":            width - 4,
                                "height":           height - 4,
                                "min-height":       "18px",
                                "z-index":          zIndex,
                                "background-color": useRGBA ? isSupplemental ? "rgba(0, 0, 255, 0.2)" : "rgba(0, 0, 0, 0.2)" : "transparent",
                                "border":           useRGBA ?
                                                    isSupplemental ? "2px solid rgba(0, 0, 255, 0.7)" : "2px solid rgba(0, 0, 0, 0.7)" :
                                                    isSupplemental ? "2px solid #00F" : "2px solid #000"
                            });

                            if (isSupplemental) {
                                $label = $(["<span>", contentLabel, "</span>"].join(""));
                            } else {
                                $label = $(["<a href='", contentEditUrl, "' target='_blank'>", contentLabel, "</a>"].join(""));
                            }

                            $(["<span>", contentModel, "</span>"].join(""))
                            .css(labelContentModelCSS)
                            .prependTo($label);

                            $label
                            .css(labelCSS)
                            .appendTo($overlay);

                            overlays.push($overlay);
                        }
                    });
                }
            });
        }

        $.fn.append.apply($("body"), overlays);
    }

    function refresh(fn, model) {
        updateModels();
        if (arguments.length > 0) {
            if (arguments.length > 1) {
                fn(model);
            } else {
                fn();
            }
        }
        renderToggles();
        renderOverlays();
    }

    function initAdminUI_overlays() {
        var $widget, $header, $enabler, $widgetBody;

        rnn.modules.user.get(function (user) {

            currentUser = user;

            useCookies = (typeof Cookies !== "undefined");
            if (useCookies) {
                enabled = !!Cookies.get("adminUIOverlays");
            }

            $widget = $("<div class='adminUIWidget'></div>");

            $header = $("<div class='adminUIWidgetHeader'><label>Overlays <a target='_blank' href='" + window.location.pathname +
                    "?overlays=1'><img style='margin:-2px 0 0 5px' src='" + rnn.site.mediaURL +
                    "rnn/base/img/14x14/external_link_icon.png'></a></label></div>"
                    ).appendTo($widget);

            $enabler = $("<input type='checkbox' />")
            .css({
                "vertical-align": "top",
                "display":        "inline",
                "margin":         "2px 10px 0 0"
            })
            .prependTo($header.find('label'))
            .bind("change", function () {
                var isChecked = $(this).is(":checked") ? true : false;
                enabled = isChecked;
                if (useCookies) {
                    if (enabled) {
                        Cookies.set("adminUIOverlays", "enabled", { path: "/" });
                    } else {
                        Cookies.remove("adminUIOverlays");
                    }
                }
                refresh();
            });

            if (enabled) {
                $enabler.attr("checked", "checked");
            }

            $widgetBody = $([
                "<div class='adminUIWidgetBody'>",
                    "<div id='overlayToggles'></div>",
                "</div>"
            ].join(""));

            $("*[data-overlay-marker]").each(function () {
                var $this, overlayData;

                $this = $(this);
                overlayData = $this.data("overlay-marker");
                if (overlayData.is_primary && currentUser.allowed_models && $.inArray(overlayData.content_type, currentUser.allowed_models) > -1) {
                    $widgetBody.prepend($([
                        "<ul><li>",
                            "<a href='", overlayData.edit_url,"' target='_blank' title='Edit \"", overlayData.label, "\"'>",
                                "Edit this ", overlayData.content_type,
                            "</a>",
                        "</li></ul>"
                    ].join("")));
                }
            });

            $widgetBody.appendTo($widget);

            rnn.modules.adminUI.addAdminUIWidget($widget);

            rnn.messaging.subscribe("adminUIWidgetToggleHovered", refresh);
            rnn.messaging.subscribe("adminUIWidgetUpdated", refresh);
            // rnn.messaging.subscribe("contentPositionChanging", destroyOverlays);
            rnn.messaging.subscribe("contentPositionChanged", refresh);

        });

    }

    enabled = false;
    models = {};

    useRGBA = true;
    (function () {
        var div = document.createElement("div");
        try {
            div.style.color = "rgba(0, 0, 0, 0.5)";
        } catch(e) {
            useRGBA = false;
        }
    })();

    rnn.modules.register("adminUI_overlays", {
        destroyOverlays: destroyOverlays,
        refresh: refresh,
        init: initAdminUI_overlays
    });

})(jQuery);